import type { ICustomMenuHead } from './ICustomMenuHead';

/**
 * Модулі з власним меню в прототипі v4 (Groundwork.dc.html: nav «Tasks», nav «Knowledge Base»): заголовок «Модуль», «N відкритих · M усього»
 * (база знань — «N оприлюднено · M усього») і основна кнопка створення на всю ширину. Решта модулів — категорія й «N записів».
 */
const HEADS: Readonly<Record<string, ICustomMenuHead>> = {
  task: { counted: 'open', newLabelKey: 'modBody.menu.newTask' },
  kb: { counted: 'published', newLabelKey: 'modBody.menu.newArticle' },
};

/** Статус «оприлюднено» бази знань (лічильник заголовка `published`). */
export const PUBLISHED_STATUS = 'Published';

/** Налаштування власного заголовка меню для модуля; undefined — звичайний заголовок. Чиста функція. */
export function customMenuHeadOf(moduleKey: string | undefined): ICustomMenuHead | undefined {
  return moduleKey ? HEADS[moduleKey] : undefined;
}

/**
 * Чи модуль має власне меню прототипу (завдання, база знань): лише в ньому є секція «Таблиці» (головна таблиця й спроєктовані таблиці модуля);
 * у решти модулів прототип таблиць у меню не показує (дочірні реалізовані — власними розділами, довідники — у «Налаштуваннях»). Чиста функція.
 */
export function hasOwnMenu(moduleKey: string | undefined): boolean {
  return Boolean(customMenuHeadOf(moduleKey));
}
